import { Box, Center, Container, Heading, Text, List, ListItem, ListIcon, Image, SimpleGrid, Icon, Stack} from "@chakra-ui/react";
import { StarIcon, WarningIcon } from '@chakra-ui/icons'
import DefaultParticle from "../components/atoms/DefaultParticle";
import ShutdownBtn from "../components/atoms/shutdownBtn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { solid, regular, brands } from '@fortawesome/fontawesome-svg-core/import.macro' // <-- import styles to be used


const HomePage = () => {
    return (
        <Box h="100vh" >
          <DefaultParticle/>
          <Center>
            <Stack>
            <Box position='relative' top='5' left='10'>
              <Heading fontFamily='Indie Flower, cursive' color='white' fontWeight='light'>Hello</Heading>
            </Box>
          
            <Container backdropBlur='3xl' padding='10' background="blueAlpha.100" maxW='8xl' pos="relative" top="5vh" borderRadius="20">
            
              <SimpleGrid columns={2} minChildWidth='500px' spacingX='5vw' spacingY='30px'>
                <Box width='70vw'>
                  <Heading color='white'>Amar Panji Senjaya</Heading>
                  <Text color='gray.400' fontWeight='light'>Moto: Livin Like Larry The Lobster</Text>
                  <br/>
                  {/* <Text color='gray.300' fontWeight='light'><Icon as={WarningIcon} color='yellow.300' /> You doesn't need to read this section this section is optional.</Text> */}
                  <Text color='gray.300'>Hi I'm Amar Panji Senjaya my friends ussually call me Amay.</Text>
                  <Text color='gray.300'>Currently i work as a Software Engineer at PT Citcall Teknologi Indonesia</Text>
                  <Text color='gray.300'>and Student at Mercu Buana University.</Text>
                  <Text color='gray.300'>If you have any question feel free to contact me.</Text>
                  <Text color='gray.200'>amarpanjis@gmail.com</Text>
                  <Text color='gray.300'>Don't worry i always check my email every morning.</Text>
                </Box>
                <Center>  
                <Box width='300px'>
                  <Center>
                    <Stack>
                  <Image
                  borderRadius='full'
                  boxSize='300px'
                  src='/profile.jpg'
                  alt='Me with Edelweiss flower at Mt. Gede 2019'
                  />
                  <Center><Text color='gray.400' fontSize='sm' fontWeight='light'>Me with Edelweiss flower at Mt. Gede 2019</Text></Center>
                  </Stack>
                </Center>
                </Box>
                </Center>
              </SimpleGrid>
              <br/>
              <Heading color='white' size='md'>Bio: </Heading>
              <List>
                <ListItem color='gray.300' backgroundColor='rgba(255, 255, 255, 0.07)' width='500px' padding='1'>
                  <FontAwesomeIcon color="#FBD38D" icon={solid('baby')} />&nbsp;
                  02 April 2001
                  <p>I was born at Bogor Indonesia.</p>
                </ListItem>
                <ListItem color='gray.300' width='500px' padding='1'>
                  <FontAwesomeIcon color="#8db3f0" icon={solid('briefcase')} />&nbsp;
                  Feb 2019 - Des 2020
                  <p>Game Developer - Blissfulworks</p>
                </ListItem>
                <ListItem color='gray.300' backgroundColor='rgba(255, 255, 255, 0.07)' width='500px' padding='1'>
                  <FontAwesomeIcon color="#2C5282" icon={solid('graduation-cap')} />&nbsp;
                  May 2019
                  <p>Graduate from Bina Profesi Bogor High School.</p>
                </ListItem>
                <ListItem color='gray.300' width='500px' padding='1'>
                  <FontAwesomeIcon color="#8db3f0" icon={solid('briefcase')} />&nbsp;
                  May 2019 - August 2019
                  <p>Software Developer - PT. Stampindo</p>
                </ListItem>
                <ListItem color='gray.300' backgroundColor='rgba(255, 255, 255, 0.07)' width='500px' padding='1'>
                  <FontAwesomeIcon color="#8db3f0" icon={solid('briefcase')} />&nbsp;
                  Nov 2021 - Present
                  <p> Software Engineer - PT. Citcall Teknologi Indonesia </p>
                </ListItem>
                <ListItem color='gray.300' width='500px' padding='1'>
                  <FontAwesomeIcon color="#9AE6B4" icon={solid('user-graduate')} />&nbsp;
                  Sep 2022 - Present
                  <p> Bachelor Of Computer Science at Mercu Buana University </p>
                </ListItem>
              </List>

              <br/>

              <Heading color='white' size='md'>I feel comfortable writing code with: </Heading>
              <List>
                <ListItem color='gray.300'>
                  <ListIcon as={StarIcon} color='yellow.500' />
                  C++
                </ListItem>
                <ListItem color='gray.300'>
                  <ListIcon as={StarIcon} color='yellow.500' />
                  Python
                </ListItem>
                <ListItem color='gray.300'>
                  <ListIcon as={StarIcon} color='yellow.500' />
                  C#
                </ListItem>
                <ListItem color='gray.300'>
                  <ListIcon as={StarIcon} color='yellow.500' />
                  Go
                </ListItem>
              </List>

              <br/>

              {/* <Heading color='white' size='md'>Tools i've used on my works: </Heading>
              <List>
                <ListItem color='gray.300'>
                  <ListIcon as={StarIcon} color='yellow.500' />
                  GIT
                </ListItem>
                <ListItem color='gray.300'>
                  <ListIcon as={StarIcon} color='yellow.500' />
                  Postgresql, Mysql, MongoDB
                </ListItem>
                <ListItem color='gray.300'>
                  <ListIcon as={StarIcon} color='yellow.500' />
                  Redis
                </ListItem>
                <ListItem color='gray.300'>
                  <ListIcon as={StarIcon} color='yellow.500' />
                  vscode, emacs, vim, sublime3, nano
                </ListItem>
                <ListItem color='gray.300'>
                  <ListIcon as={StarIcon} color='yellow.500' />
                  unity3D
                </ListItem>
                <ListItem color='gray.300'>
                  <ListIcon as={StarIcon} color='yellow.500' />
                  renpy
                </ListItem>
                <ListItem color='gray.300'>
                  <ListIcon as={StarIcon} color='yellow.500' />
                  and a lot more.
                </ListItem>
              </List>

              <br/> */}

            <Center>
              <Heading color='white' size='md'>Tech stack for this site </Heading>
            </Center>
            <br />
            <Center>
              <Image
                    borderRadius='full'
                    boxSize='100px'
                    src='/icons8-chakra-ui-240.png'
                    alt='Chakra-UI'
                    />
              <Image
                  borderRadius='full'
                  boxSize='100px'
                  src='/icons8-react-160.png'
                  alt='Chakra-UI'
                  />
              <Image
                  borderRadius='full'
                  boxSize='100px'
                  src='/icons8-typescript-240.png'
                  alt='Chakra-UI'
                  />
            </Center>
            <br /><br />
            <Center top='10px' pos='relative'>
              <Text color='gray.400' fontWeight='light'>&copy; Amar Panji Senjaya 2019 - 2022</Text>
            </Center>
            </Container>
            </Stack>
          </Center>
       </Box>
    )
};

export default HomePage;